export default {"src":"/_next/static/media/icon_play_tungsten_events.71427751.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};